/*
Purpose: Explains the card iconography under the Calendar (v2) grid.
*/

import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { DELIVERY_MODE, DELIVERY_MODE_META, DISPLAY_STATUS, DISPLAY_STATUS_META } from '../constants';
import { modeIconFor, statusIconFor } from './badges';

const MODE_ITEMS = [
  { mode: DELIVERY_MODE.IN_CENTRE, hint: 'Attending at the centre' },
  { mode: DELIVERY_MODE.ONLINE, hint: 'Attending remotely' },
  { mode: DELIVERY_MODE.FLEXI, hint: 'Lesson can be accessed from home for 7 days' },
];  

const STATUS_ITEMS = [
  { status: DISPLAY_STATUS.PENDING, hint: 'Scheduled, no login yet' },
  { status: DISPLAY_STATUS.ONGOING, hint: 'Logged in and in progress' },
  { status: DISPLAY_STATUS.ATTENDED, hint: 'Attendance confirmed' },
  { status: DISPLAY_STATUS.MISSED, hint: 'No login recorded' },
  { status: DISPLAY_STATUS.DEFER_REQUESTED, hint: 'Awaiting an admin decision' },
  { status: DISPLAY_STATUS.SLOT_ASSIGN, hint: 'Approved, awaiting a make-up slot' },
  { status: DISPLAY_STATUS.ONE_OFF_REQUESTED, hint: 'One-off session requested' },
  { status: DISPLAY_STATUS.CANCELLED, hint: 'Lesson removed from the schedule' },
];

/** Coloured tile plus label and one-line explanation. */
function LegendItem({ Icon, label, hint, background, color }) {
  return (
    <div className="cv2-legend__item">
      <span className="cv2-legend__icon" style={{ background, color }}>
        <Icon className="cv2-icon" />
      </span>
      <span>
        <span className="cv2-legend__label">{label}</span>
        <span className="cv2-legend__hint">{hint}</span>
      </span>
    </div>
  );
}

LegendItem.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default function LegendPanel() {
  return (
    <section className="cv2-legend">
      <h2 className="cv2-legend__title">
        <InfoOutlinedIcon className="cv2-icon" />
        Legend
      </h2>

      <div className="cv2-legend__grid">
        {MODE_ITEMS.map((item) => (
          <LegendItem
            key={item.mode}
            Icon={modeIconFor(item.mode)}
            label={DELIVERY_MODE_META[item.mode].label}
            hint={item.hint}
            background={`var(--cv2-mode-${item.mode === DELIVERY_MODE.IN_CENTRE ? 'centre' : item.mode})`}
            color="#fff"
          />
        ))}

        {STATUS_ITEMS.map((item) => {
          const tone = DISPLAY_STATUS_META[item.status].tone;
          return (
            <LegendItem
              key={item.status}
              Icon={statusIconFor(item.status)}
              label={DISPLAY_STATUS_META[item.status].label}
              hint={item.hint}
              background={`var(--cv2-${tone}-bg)`}
              color={`var(--cv2-${tone}-ink)`}
            />
          );
        })}
      </div>
    </section>
  );
}
